import { createContext } from 'react';
import type { InputProps } from '../input/input';

export const InputGroupContext = createContext<(props: InputProps) => void>(
  () => {}
);
